import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

export function UnauthorizedPage() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center gap-5 bg-background px-6 text-center">
      <div className="flex h-11 w-11 items-center justify-center rounded-full bg-warning/10">
        <ShieldAlert className="h-5 w-5 text-warning" aria-hidden="true" />
      </div>
      <div className="flex flex-col gap-1.5">
        <h1 className="font-display text-xl font-semibold">You don't have access to this page</h1>
        <p className="max-w-sm text-sm text-muted-foreground">
          Your role in this organization doesn't include this area. Ask an owner or admin to update your
          permissions if you think this is a mistake.
        </p>
      </div>
      <Button asChild>
        <Link to="/dashboard">Back to dashboard</Link>
      </Button>
    </div>
  );
}
